<form autocomplete="off" [formGroup]="form" (ngSubmit)="save()">
    <div class="d-flex justify-content-start align-items-center w-100 mb-3">
        <button class="btn btn-sm btn-outline-secondary me-3" (click)="goBackToVersionList()">
            <i class="fa fa-arrow-start" aria-hidden="true"></i> Volver
        </button>
        <div class="flex-grow-1 text-center">
            <h4>Detalle de la ficha : {{t3.code}} [V.{{t3.version}}]
                <a [routerLink]="(!t3.isActive || !t3.status) ? '/ficha-test/' + t3.id : '/ficha/' + t3.code"
                    target="_blank">
                    {{ t3.longtitle }}
                    <i class="fa fa-external-link" aria-hidden="true"></i>
                </a>
            </h4>
        </div>
    </div>
    <hr>
    <div class="col-12 mb-5">
        <div class="alert alert-info text-start" role="alert">
            <strong>1. Cargar documento Word:</strong> Este botón le permite cargar un documento Word con la ficha que
            ha creado.
            <br><br>
            <small>
                <strong>Nota sobre numeración y notas:</strong>
                <ul>
                    <li>Para la numeración de gráficos, utilice los términos: <em>Figura 1., Cuadro 2., Tabla 3., Fuente
                            4.</em></li>
                    <li>Para las notas de los gráficos, utilice los términos: <em>Nota, Nota técnica, Fuente.</em></li>
                </ul>
            </small>
        </div>
    </div>
    <div class="textOnInput col-12 mb-5">
        <label class="form-label" for="inputText">Cargar Documento DOCX</label>
        <div class="label-container">
            <div class="row">
                <div class="col-md-12" style="margin-bottom: 10px;">
                    <div class="input-group">
                        <div class="input-group-append">
                            <button class="btn btn-outline-primary custom-rounded-button" type="button"
                                (click)="fileInput.click()">
                                Cargar
                            </button>
                        </div>
                        <input type="text" disabled class="form-control" [value]="fileName || ''" autocomplete="off">
                    </div>
                    <input #fileInput type="file" id="input-file-docx" (change)="onFileChange($event)" accept=".docx"
                        style="display: none;">
                </div>
            </div>
        </div>
    </div>
    <div class="col-12">
        <div class="alert alert-warning text-start" role="alert">
            <strong>2. Verificar y ajustar:</strong> En el editor a continuación, podrá revisar el documento Word
            cargado. Verifique que todos los elementos estén presentes y en el orden correcto. Si es necesario,
            puede corregir o ajustar el contenido en el editor, o cargar un nuevo documento corregido.
        </div>
    </div>

    <div class="col-md-12 text-end">
        <button type="button" class="btn btn-sm btn-outline-secondary" (click)="updateReferences()">
            <i class="fas fa-sync-alt mr-2"></i>
            Referencias bibliográficas
        </button>
        <small class="text-muted d-block mt-2">
            Para insertar los links de las las referencias bibliográficas en las citas, primero deberá guardar el documento.
        </small>
    </div>

    <div class="col-12 mb-5">
        <div class="row">
            <quill-editor formControlName="content" [modules]="modulesQuill"></quill-editor>
        </div>
    </div>
    <div class="col-12 mb-5">
        <div class="alert alert-success text-start" role="alert">
            <strong>3. Guardar cambios:</strong> Una vez que el documento esté listo, haga clic en el botón verde
            "Guardar" para almacenar los cambios en el sistema.
        </div>
    </div>
    <div class="col-md-12" *ngIf="isSaving" class="text-center">
        <p>Guardando, por favor espere...</p>
        <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Cargando...</span>
        </div>
    </div>


    <div class="row">
        <div class="col-12">
            <div class="d-flex justify-content-start">
                <div class="me-2">
                    <button type="button" class="btn btn-outline-secondary btn-block" (click)="cancel()"
                        [disabled]="isSaving">
                        Cancelar
                    </button>
                </div>
                <div>
                    <button type="submit" class="btn btn-outline-primary btn-block" [disabled]="isSaving">
                        Guardar
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="col-12 mt-5">
        <div class="alert alert-success text-start" role="alert">
            <strong>4. Previsualización de la ficha:</strong>
            Desde este enlace puede ver la <a
                [routerLink]="(!t3.isActive || !t3.status) ? '/ficha-test/' + t3.id : '/ficha/' + t3.code"
                target="_blank">
                previzualización <i class="fa fa-external-link" aria-hidden="true"></i>
            </a> de su ficha antes de publicarlo.
        </div>
    </div>
</form>